export default __webpack_public_path__ + "static/media/06.51cb78eb.jpg";